import React from 'react'
import { Button, csx, IconCaretLeft, IconCaretRight } from '@vtex/admin-ui'

export type NavButtonProps = {
  direction: 'prev' | 'next'
  onClick: () => void
}

export const NavButton = ({ direction, onClick }: NavButtonProps) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    onClick={onClick}
    className={csx({
      position: 'absolute',
      top: '50%',
      padding: '$space-4',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      ...(direction === 'next' ? { right: '$space-1' } : { left: '$space-1' }),
    })}
  >
    <Button
      icon={
        direction === 'next' ? (
          <IconCaretRight size="small" />
        ) : (
          <IconCaretLeft size="small" />
        )
      }
      className={csx({
        borderRadius: '50%',
        padding: '10px !important',
      })}
    />
  </div>
)
